import { render } from "./MiniBannerComponent.vue?vue&type=template&id=34e9548c"
import script from "./MiniBannerComponent.vue?vue&type=script&lang=js"
export * from "./MiniBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__